import { __assign, __extends } from "tslib";
import * as React from 'react';
import s from './ProductLineItemThumbnail.scss';
import { ItemLink } from '../partials/ItemLink/ItemLink';
import { getMediaDimensions } from '../utils/itemUtilsWithSideEffect';
import { ProductThumbnail } from '../../ProductThumbnail';
var ProductLineItemThumbnail = /** @class */ (function (_super) {
    __extends(ProductLineItemThumbnail, _super);
    function ProductLineItemThumbnail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProductLineItemThumbnail.prototype.render = function () {
        var _a = this.props, product = _a.product, onImageClick = _a.onImageClick, imageRef = _a.imageRef;
        return (React.createElement("div", { className: s.thumbnail }, imageRef && onImageClick ? (React.createElement(ItemLink, { onImageClick: onImageClick, imageRef: imageRef },
            React.createElement(ProductThumbnail, __assign({ product: product }, getMediaDimensions(product, { width: 100, height: 100 }), { mountedToDOM: true })))) : (React.createElement(ProductThumbnail, __assign({ product: product }, getMediaDimensions(product, { width: 100, height: 100 }), { mountedToDOM: true })))));
    };
    ProductLineItemThumbnail.displayName = 'ProductLineItem.Image';
    return ProductLineItemThumbnail;
}(React.PureComponent));
export { ProductLineItemThumbnail };
//# sourceMappingURL=ProductLineItemThumbnail.js.map